import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ theme, displayState }) => css`
    cursor: pointer;
    &:hover {
      color: ${displayState?.color ?? theme?.colour?.primary ?? '#1DBD6B'};
      text-decoration: underline;
    }
  `}
`;

export default Wrapper(template)
